<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Programa de Servicios (Tab IV)',
      routes: ["Informes", "Programa de Servicios (Tab IV)"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYear: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onHandlerSearch() {
      
      this.process();
    },
    async process() {
      const params = {
        AcademicYearId: this.model.search.filters.academicYear.id,
      };

      await ReportServices.getReport('peitabIVstudentservices', params)
        .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>